import {createContext} from 'react'

export default createContext({
  changeActiveArea: () => {},
  activeArea: null,
})
